define('modules/content_recommendations/modal/pause_modal',[
  'backbone',
  '_',
  'text!./pause_modal_template.html',
], function (Backbone, _, modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'content-recommendations-pause-modal',
    template: _.template(modal_template),

    events: {
      'click .js-confirm-button': 'confirmPause',
    },

    render: function () {
      this.$el.html(this.template({ bookingIds: this.bookingIds }));
      return this;
    },

    confirmPause: function () {
      if (this.type === 'content_recommendation') {
        Backbone.trigger('changeItemsStatusContentRecommendations', this.bookingIds, false);
      }   
      else {
        Backbone.trigger('changeItemsStatusAds', this.bookingIds, false);
      }
      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});
